var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.loaded)?_c('div',[(_vm.$store.state.loggedIn)?_c('div',[_c('painel')],1):_c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$store.state.evento.descricao)}}),_vm._v(" "),_c('inscricao')],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-030db0c1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 734
// module chunks = 1